import { companyApi } from 'container/companyApi';
import { CompanyRepository } from 'repository/CompanyRepository';

export const companyRepository: CompanyRepository = new CompanyRepository(companyApi);
